module.exports = __webpack_public_path__ + "img/har_region_logo.73cc67b6.jpg";